export const VERSION_STORAGE_KEY = 'app_version';
export const VERSION_DISMISS_KEY = 'version_update_dismissed';
export const VERSION_RELOAD_GUARD_KEY = 'last_version_reload';

export const VERSION_POLL_MS = 5 * 60 * 1000;
export const VERSION_MIN_CHECK_MS = 60 * 1000;
export const VERSION_SNOOZE_MS = 5 * 60 * 1000;
export const VERSION_AUTO_RELOAD_SEC = 30;
export const VERSION_RELOAD_GUARD_MS = 5000;
